import Dialog, { DialogTitle } from 'material-ui/Dialog'
import List, { ListItem, ListItemText } from 'material-ui/List'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Profile from './components/Profile'
import { Button, launcherOpenProfilesDialog } from '../../imports'
import styles from '../../styles.scss'

class ProfileSelector extends Component {
    setProfile = (profile) => {
        this.props.setProfile(profile)
        this.props.dismiss()
    }

    handleRequestClose = () => {
        this.props.dismiss()
    }

    render() {
        if (this.props.userProfile == null) return <div />

        const { setProfile, dismiss, ...passThroughProps } = this.props
        const options = {
            setValue: this.setProfile,
            handleRequestClose: this.handleRequestClose,
            ...passThroughProps,
        }

        // return <MaterialSelector {...options} />
        return <VanillaSelector {...options} />
    }
}

ProfileSelector.propTypes = {
    // title: PropTypes.string,
    userProfile: PropTypes.string,
    // profiles: PropTypes.arrayOf(PropTypes.string),
    // manageProfilesText: PropTypes.string,
    setProfile: PropTypes.func,
    dismiss: PropTypes.func,
    // open: PropTypes.bool,
    // boundingRectangle: PropTypes.shape({
    //     // x: PropTypes.number,
    //     // y: PropTypes.nu,
    //     // bottom: PropTypes.number,
    //     left: PropTypes.number,
    //     // right: PropTypes.number,
    //     top: PropTypes.number,
    //     // width: PropTypes.number,
    //     height: PropTypes.number,
    // }),
}

// eslint-disable-next-line
class VanillaSelector extends Component {
    constructor(props) {
        super(props)

        this.state = {
            top: 0,
            left: 0,
        }
    }

    componentDidMount() {
        this.calculatePosition()
    }

    handleClick = (e) => {
        if (this.ref.contains(e.target)) {
            return
        }

        this.props.handleRequestClose()
    }

    calculatePosition = () => {
        const bodyRect = document.body.getBoundingClientRect()
        const btnRect = this.props.boundingRectangle
        const box = this.ref.getBoundingClientRect()

        if (btnRect == null) {
            // We just calculate the body middle instead

            // ------------------------
            // Calculate the Y position
            // ------------------------
            // eslint-disable-next-line
            let top = bodyRect.height / 2 - box.height / 2

            // Now parse the result to get an int
            top = parseInt(top, 10)

            // Make sure the popup newer shows up to high up
            if (top < 30) top = 30

            // ------------------------
            // Calculate the X position
            // ------------------------
            // eslint-disable-next-line
            let left = bodyRect.width / 2 - box.width / 2

            // Now parse the result to get an int
            left = parseInt(left, 10)

            this.setState({ top, left })
        } else {
            // ------------------------
            // Calculate the Y position
            // ------------------------
            // Calculate half the height of the target element
            const btnHeight = btnRect.height / 2

            // How far from the top of the screen is the center of the target element
            // eslint-disable-next-line
            const btnOffsetTop = btnRect.top + btnHeight - bodyRect.top

            // How far has the user scrolled?
            const scroll = document.documentElement.scrollTop || document.body.scrollTop

            // Top is distance from top of screen to center of button - how far
            // the user has scrolled - half the height of the popup
            // eslint-disable-next-line
            let top = btnOffsetTop - box.height / 2 - scroll

            // Now parse the result to get an int
            top = parseInt(top, 10)

            // Make sure the popup newer shows up to high up
            if (top < 30) top = 30

            // ------------------------
            // Calculate the X position
            // ------------------------
            // How far from the left of the screen is the center of the target element
            const btnOffsetLeft = btnRect.left - bodyRect.left

            // Left is distance from left of screen to left of button - width of the popup
            // and finally subtract 10 to have a 10px padding
            let left = btnOffsetLeft - box.width - 10

            // Now parse the result to get an int
            left = parseInt(left, 10)

            this.setState({ top, left })
        }
    }

    render() {
        let noProfileSelected = true
        const profiles = this.props.profiles.map((profile) => {
            if (profile === this.props.userProfile) noProfileSelected = false
            return (
                <Profile
                    key={profile}
                    name={profile}
                    selected={profile === this.props.userProfile}
                    setProfile={() => this.props.setValue(profile)}
                />
            )
        })

        if (noProfileSelected && this.props.profiles.length > 0) {
            this.props.setValue(this.props.profiles[0])
        }

        return (
            <div
                role="presentation"
                className={styles.background}
                onClick={e => this.handleClick(e)}
            >
                <div
                    ref={ref => (this.ref = ref)}
                    className={styles.container}
                    style={{ top: this.state.top, left: this.state.left }}
                >
                    <h3 className={styles.title}>{this.props.title}</h3>
                    <div className={styles.content}>
                        <ul>{profiles}</ul>
                        <Button onClick={() => launcherOpenProfilesDialog()}>
                            {this.props.manageProfilesText}
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
}

VanillaSelector.propTypes = {
    title: PropTypes.string,
    userProfile: PropTypes.string,
    profiles: PropTypes.arrayOf(PropTypes.string),
    manageProfilesText: PropTypes.string,
    handleRequestClose: PropTypes.func,
    setValue: PropTypes.func,
    boundingRectangle: PropTypes.shape({
        // x: PropTypes.number,
        // y: PropTypes.nu,
        // bottom: PropTypes.number,
        left: PropTypes.number,
        // right: PropTypes.number,
        top: PropTypes.number,
        // width: PropTypes.number,
        height: PropTypes.number,
    }),
}

const MaterialSelector = (props) => {
    const profiles = props.profiles.map(profile => (
        <ListItem button onClick={() => this.props.setValue(profile)} key={profile}>
            <ListItemText primary={profile} />
        </ListItem>
    ))

    return (
        <Dialog onRequestClose={props.handleRequestClose} open={props.open}>
            <DialogTitle>{props.title}</DialogTitle>
            <div>
                <List>{profiles}</List>
                <Button style={{ display: 'block' }} onClick={() => launcherOpenProfilesDialog()}>
                    {props.manageProfilesText}
                </Button>
            </div>
        </Dialog>
    )
}

MaterialSelector.propTypes = {
    title: PropTypes.string,
    profiles: PropTypes.arrayOf(PropTypes.string),
    manageProfilesText: PropTypes.string,
    open: PropTypes.bool,
    handleRequestClose: PropTypes.func,
    setValue: PropTypes.func, // eslint-disable-line
    // For some reason eslint isn't picking up on the fact that setValue is actually in use...
}

export default ProfileSelector



// WEBPACK FOOTER //
// ./src/features/ProfileSelector/components/Selector/component.js